"use strict";

const CommentForm = {
  maxCommentCharLength: 1000,
  /**
   * コメント欄に入力した時に発火する処理をまとめる
   */
  onInputFunctions() {
    this.activateSubmitButton();
  },
  onLoadedFunctions() {},
  /**
   * コメント欄に入力されたら、送信ボタンを活性化して押せるようにする
   */
  activateSubmitButton() {
    const commentInput = window.event.target;
    const inputValue = commentInput.value;
    // コメント本文のバリデーションに通らなかったら早期リターン
    const commentInputButton = document.getElementById("commentInputBtn");
    if (this.validComment(inputValue)) {
      commentInputButton.disabled = false;
    } else {
      commentInputButton.disabled = true;
    }
  },
  /**
   * コメント入力内容のバリデーション
   *
   * @param {String} comment
   * @return {boolean}
   */
  validComment(comment) {
    // スペース、改行以外の文字列がない場合は無効コメントとする
    const regexp = /\S+/g;
    if (comment.match(regexp) == null) return false;
    return true;
  },
  /**
   * コメント投稿時に気になるボタンを有効化する
   *
   */
  async activateBookmarkButtons() {
    document.querySelector(".sending").style.display = "block";
    const fav = document.querySelector(".serviceDetail .fav");
    if (!fav || fav.classList.contains("is_active")) return;
    fav.classList.add("is_active");
  },
};
/**
 * ページロード後にグローバル定数にCommentFormを追加する
 */
document.addEventListener("DOMContentLoaded", () => {
  Object.defineProperty(globalThis, "CommentForm", {
    value: CommentForm,
    writable: false,
  });
  CommentForm.onLoadedFunctions();
});
